import React from "react";
import { Button } from "../..";
import { Modal } from "react-bootstrap";
import { CustodianCashBalancesFilterModalProps, CustodianCashBalancesFilter, CustodianCashBalancesFilterModalForm } from "./types";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { FormProvider, useForm } from "react-hook-form";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";
import { ClientProjectProvider } from "../../../hooks/ClientProjectContext";
import { CompletedReviewsDefaultFilters, CustodianCashBalancesDefaultFilters } from "../../../hooks/FilterContext";
import ThemedModal from "../../utilities/ThemedModal";
import { CustodianCashBalancesFilterForm } from "./form";

const CustodianCashBalancesFilterModal = ({
    backdrop = 'static',
    cancel,
    centered = true,
    defaultFilters,
    defaultValues,
    dialogId,
    dismiss,
    proceed,
    show,
    size = "lg",
    ...rest
} : Readonly<CustodianCashBalancesFilterModalProps>) => {

    const [bodyAnimation] = useAutoAnimate();
    const formMethods = useForm<CustodianCashBalancesFilterModalForm>();
    const { handleSubmit, reset } = formMethods;

    const onClose = () => cancel!();

    const onClearFilters = () => proceed!({ ...defaultFilters });

    const onSubmit = (form: CustodianCashBalancesFilterModalForm) => proceed!(form);

    // whenever the default values change/we basically open the modal here.
    React.useEffect(() => {
        if (!defaultValues) {
            return;
        }
        reset({ ...defaultValues });
    }, [ defaultValues ]);

 return (
        <Modal backdrop={backdrop} centered={centered} size={size} show={show} onHide={onClose} {...rest}>
            <ThemedModal.Header>
                <Modal.Title>Cash Balance Filters</Modal.Title>
            </ThemedModal.Header>
            <FormProvider {...formMethods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Body ref={bodyAnimation}>
                        <CustodianCashBalancesFilterForm  />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="warning" type="button" onClick={onClearFilters}>Clear Filters</Button>
                        <Button variant="success" type="submit">Apply Filters</Button>
                        <Button variant="light" type="button" onClick={onClose}>Cancel</Button>
                    </Modal.Footer>
                </form>
            </FormProvider>
        </Modal>
    );
}

export function openCustodianCashBalanceFilters(filters: CustodianCashBalancesFilter) {
    return createConfirmation<CustodianCashBalancesFilterModalProps, CustodianCashBalancesFilterModalForm>(confirmable((props) => {
        return <CustodianCashBalancesFilterModal {...props} />
    }))({
        dialogId: 'custodian_cash_balances_filter_modal',
        defaultValues: { ...filters },
        defaultFilters: CustodianCashBalancesDefaultFilters
    });
}